import React, {useEffect, useRef} from 'react';
import './LeaderboardInt.css';
import LeaderBoardTopInt from "./LeaderBoardTopInt"
import RankingInt from '../LeaderboardInt/RankingInt';
import {useHistory} from "react-router-dom";
import Slider from "react-slick";
import {useSwipeable} from "react-swipeable";
import {
    resolveTutorDetailsLeaderboardAsset,
    tutorDetailsLeaderboardConfig,
    globalColors,
    globalBackgrounds,
} from './tutorDetailsLeaderboardConfig';
function LeaderboardInt(props) {
    const { data, myorg, swipeActions, scrollNav } = props;
    const text = tutorDetailsLeaderboardConfig.text || {};
    const images = tutorDetailsLeaderboardConfig.images || {};
    const backgrounds = tutorDetailsLeaderboardConfig.backgrounds || {};
    const topData = data?.teamRankings?.slice(0, 3)
    const belowData = data?.teamRankings?.slice(3, data?.teamRankings?.length);
    const history = useHistory();
    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: (dots) => <ul>{dots}</ul>,
        customPaging: (i) => (
            <div className="slick-indicator"></div>
        ),
    };

    const gainerSwipeActions = useSwipeable({
        onSwipedLeft: (eventData) => {
            eventData.event.stopPropagation();
        },
        onSwipedRight: (eventData) => {
            eventData.event.stopPropagation();
        },
        preventScrollOnSwipe: true,
    });
    const leaderboardStyle = {
        '--leaderboard-previous-winners-heading': globalColors.heading_color || '#232E4F',
        '--leaderboard-previous-winners-highlight': globalColors.accent_color || '#E35C22',
        '--leaderboard-previous-winners-subtitle': globalColors.dark_accent || '#3D1534',
        '--leaderboard-winner-frame-background': globalColors.accent_color || '#E35C22',
        '--leaderboard-carousel-indicator': globalColors.dark_accent || '#3D1534',
        '--leaderboard-carousel-indicator-active': globalColors.secondary_accent || '#DE3F76',
        '--leaderboard-podium-background': globalColors.card_background || '#FFF1DAB2',
        '--leaderboard-podium-border': globalColors.accent_color || '#E35C22',
        '--leaderboard-podium-accent': globalColors.accent_color || '#E35C22',
        '--leaderboard-first-place-background': globalColors.light_accent || '#FFD3B1',
        '--leaderboard-ranking-table-background': globalColors.page_background || '#FEF2DF',
        '--leaderboard-ranking-table-border': globalColors.accent_color || '#E35C22',
        '--leaderboard-ranking-text': globalColors.accent_color || '#E35C22',
        '--leaderboard-current-organization-text': globalColors.accent_color || '#E35C22',
        '--leaderboard-points-label': globalColors.accent_color || '#E35C22',
        '--leaderboard-rank-badge-gradient': globalColors.accent_color || '#E35C22',
        '--leaderboard-inverse-text': globalColors.white_text || '#fff',
        '--leaderboard-points-gradient': backgrounds.points_gradient || 'linear-gradient(180deg, #D51437 0%, #930F27 100%)',
        '--leaderboard-rank-number-gradient': globalColors.accent_color || '#E35C22',
    };

  return (
      <>

      <div className="page-content page-content-leaderBoard" {...swipeActions} style={leaderboardStyle}>
          <div className="leader-board-table-data">
              <LeaderBoardTopInt data={topData} info={data?.info} inPage={true} config={tutorDetailsLeaderboardConfig}/>
              <RankingInt data={belowData} myorg={myorg}/>
          </div>
          <div className="gainer-inner-box">
              <h2><span>{text.previous_winners_highlight || 'Top 3 Educators'}</span> {text.previous_winners_suffix || 'from our last campaign'}</h2>
              <p>{text.previous_winners_subtitle || 'and their Winnings'}</p>
              <div className="last-gainer-slider" {...gainerSwipeActions}>
                  <Slider {...settings} ref={sliderRef}>
                      {(images.winner_images || [
                          'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-1.png',
                          'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-2.png',
                          'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-3.png',
                      ]).map((image, index) => (
                          <div className="last-gainer-box" key={image}>
                              <div className="gainer-img">
                                  <img src={resolveTutorDetailsLeaderboardAsset(image)} alt={`lastgainerimg${index + 1}`}/>
                              </div>
                          </div>
                      ))}
                  </Slider>
              </div>
          </div>
          <div className="leader-board-last-box">
              <img
                  src={images.bottom_navigation_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/afd35154-bedc-4a9f-9f51-5f4e8c53444e.png'}
                  onClick={() => {
                      scrollNav(1);
                      history.replace({pathname: '/tutor/details/tasks'})
                  }}
                  alt="leaderboardGiftCardPlayer"/>
          </div>
      </div>
      </>
  );
}

export default LeaderboardInt;
